<div class="flex items-center justify-between pr-6">
   <div
      class="mat-headline-small mb-0"
      mat-dialog-title
   >
      @if (data.approvalRequest?.id) {
         {{ data.approvalRequest.title ?? ('approval.edit_request' | translate) }}
      } @else {
         {{ 'approval.new_request' | translate }}
      }
   </div>
   <div class="flex grow items-center gap-4">
      @if (data.approvalRequest?.status?.slug) {
         <webvis-feature-approval-status-badge [approvalStatus]="data.approvalRequest?.status" />
      }
   </div>

   <button
      (click)="useFullScreen.set(!useFullScreen())"
      [matTooltip]="(useFullScreen() ? 'general.collapse' : 'general.expand') | translate"
      mat-icon-button
   >
      <fa-icon [icon]="useFullScreen() ? ['far', 'arrows-minimize'] : ['far', 'arrows-maximize']" />
   </button>

   <button
      class="close-button"
      mat-dialog-close
      mat-icon-button
   >
      <fa-icon [icon]="['far', 'close']"></fa-icon>
   </button>
</div>

<mat-dialog-content
   [class.grid-cols-[1fr_19fr]]="useFullScreen()"
   [class.grid-cols-[1fr_2fr]]="!useFullScreen()"
   class="overflow-y-auto grid gap-8 max-h-full transition-[grid-template-columns] duration-300 ease-in-out"
>
   <div class="flex flex-col">
      @if (!clientId()) {
         <div class="mb-4">
            <shared-ui-client-select-dropdown
               (selectionChange)="clientSelect($event)"
               [clientFormControl]="fg.controls.client"
            />
         </div>
      }

      <div
         [class.opacity-40]="!clientId()"
         [class.pointer-events-none]="!clientId()"
         class="flex flex-col gap-4"
      >
         <shared-ui-text-input
            [inputFormControl]="fg.controls.title"
            [label]="'approval.title' | translate"
         />
         <shared-ui-date-input
            [inputFormControl]="fg.controls.deadline"
            [label]="'approval.deadline' | translate"
         />
         <shared-ui-text-input
            [inputFormControl]="fg.controls.description"
            [label]="'approval.description' | translate"
            class="w-full"
            type="multi"
         />
         <shared-ui-text-input
            [inputFormControl]="fg.controls.metadata"
            [label]="'approval.attachment_url' | translate"
            class="w-full"
         />

         <mat-divider class="pb-4 mt-4"></mat-divider>
      </div>

      <webvis-feature-approval-reviewers-section
         [clientId]="clientId()"
         [control]="fg.controls.reviewers"
         class="py-4"
      />
   </div>

   @if (!fg.controls.metadata.hasError('url') && fg.controls.metadata.value) {
      <div class="flex flex-col overflow-hidden min-h-0 min-w-0">
         <webvis-feature-approval-url-preview
            (notFound)="onNotFound($event)"
            [saveFileName]="fg.controls.title.value"
            [url]="fg.controls.metadata.value"
            class="flex-1 overflow-hidden"
         />
      </div>
   } @else {
      <div class="text-lg font-bold min-w-0">{{ 'approval.select_url_for_preview' | translate }}</div>
   }
</mat-dialog-content>

<mat-dialog-actions>
   @if (!data.approvalRequest?.id || canEditApproval()) {
      <button
         [disabled]="saving()"
         mat-button
         mat-dialog-close
      >
         {{ 'general.cancel' | translate }}
      </button>
      <button
         (click)="onSave()"
         [disabled]="!fg.dirty"
         [loading]="saving()"
         mat-flat-button
      >
         {{ 'general.save' | translate }}
      </button>
   } @else {
      <button
         mat-button
         mat-dialog-close
      >
         {{ 'general.close' | translate }}
      </button>
   }
</mat-dialog-actions>
